<template>
<div class="c-cardWrapper">
  <div class="c-card">
    <a class="c-card__link" :href="`/kodate/${propdata.id}/`">
      <div class="c-card__topLabel">
        <span class="c-card__kind">{{isValuedKind(propdata.kind)}}</span>
        <span class="c-card__kodateName">{{propdata.name}}</span>
      </div>
      <div class="c-card--image" v-if="((propdata.priority === 0 || propdata.priority === '0') && mode == 'prod')">
        <figure>
          <img
            :src="require('@/assets/images/logo.png')"
          >
        </figure>
        <div class="c-card--image__info" >
          <div class="c-card--image__info__banner">{{isValued(propdata.building_method)}}・{{isValued(propdata.layout)}}</div>
          <span class="c-card--image__info__drive">{{propdata.driveway}}</span>
        </div>
        <div class="c-card--image__filter" ></div>
      </div>
      <div class="c-card--image" v-else>
        <img
          :src="imageRender(propdata.image, propdata.priority, mode)"
        >
      </div>
    </a>
    <!-- TODO: データ当て込み、js実装 -->
    <!-- <div class="c-card__pullDownArea">
      <p class="c-card__pullDownText">
        ここにタイトルここにタイトルここにタイトルここにタイトルここにタイトルここにタイトル
        ここにタイトルここにタイトルここにタイトルここにタイトルここにタイトルここにタイトル
        ここにタイトルここにタイトルここにタイトルここにタイトルここにタイトルここにタイトル
        ここにタイトルここにタイトルここにタイトルここにタイトルここにタイトルここにタイトル
      </p>
      <img src="@/assets/images/icon-plus.png" alt="">
      <img src="@/assets/images/icon-minus.png" alt="">
    </div> -->
    <p class="c-card__price">{{propdata.price}}</p>
    <p class="c-card__layout">{{layout}}</p>
    <p class="c-card__access">{{propdata.address}}</p>
    <p class="c-card__access">{{propdata.access_name_1 ? propdata.access_name_1 : propdata.access[0].name}}</p>

    <div v-if="propDataEnhanced.data.pick_ups.length > 0" class="c-card__pullDownArea c-card__pullDownArea--oneLine">
      <p class="c-card__pullDownText" :class=" { 'c-card__pullDownText--oneLine' : !isEnvironmentOpen}" >
        {{propDataEnhanced.data.pick_ups.join('、')}}
      </p>
      <span class="c-card__pullDownText__img" @click="isEnvironmentOpen = !isEnvironmentOpen">
        <img :src="!isEnvironmentOpen ? require('@/assets/images/icon-plus.png') : require('@/assets/images/icon-minus.png')" alt="">
      </span>
    </div>

    <p class="c-card__area">
      <span class="c-card__areaTitle">[建物面積]</span>
      <span class="c-card__areaText">
        {{propdata.building_area.replace(/m2/g,'㎡')}}
      </span>
      <!-- <common-area-changer
        :size="14"
        :unit="true"
        :isCard="true"
      /> -->
    </p>
    <p class="c-card__area">
      <span class="c-card__areaTitle">[土地面積]</span>
      <span class="c-card__areaText">
        {{propdata.land_area.replace(/m2/g,'㎡')}}
      </span>
      <!-- <common-area-changer
        :size="14"
        :unit="true"
        :isCard="true"
      /> -->
    </p>

    <div class="c-card__compArea">
      <p class="c-card__compText">完成時期: {{propDataEnhanced.data.built_at_within}}</p>
      <p class="c-card__compText">構造・工法: {{propdata.building_method}}</p>
    </div>

    <p class="c-card__companyName">{{propdata.contact_name}}</p>
    <p class="c-card__companyAddress">{{propdata.contact_address}}</p>
    <a class="c-card__companyTel" :href="`tel:${propDataEnhanced.data.contact_tel}`" v-if="propDataEnhanced.data.contact_tel">
      TEL : {{propDataEnhanced.data.contact_tel}}
    </a>
    <button class="c-card__leadButton" @click="gotoProp">この物件を詳しく見る</button>
  </div>
  <button v-if="isFavorite" class="c-card__favorite" :class="{'c-card__favorite__off': !isAdded, 'c-card__favorite__on': isAdded}" @click.stop="toggleFavorite"></button>
  <img
    v-if="isBalloon"
    class="c-card__favorite--balloon"
    :src="require('@/assets/images/balloon/fav.png')"
  />
</div>

</template>

<script>
import MixinUtil from '@/plugins/mixin-utils';
import MixinAPIs from '@/plugins/mixin-api';
import CommonAreaChanger from '@/components/parts/CommonAreaChanger';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';


export default {
  name: 'CommonPropertyCard',
  mixins: [MixinUtil, MixinAPIs, BehaviorLogMixin],
  props: ['propdata', 'isFavorite', 'mode'],
  components: {
    CommonAreaChanger,
  },
  data() {
    return {
      isAdded: false,
      list: [],
      isBalloon: false,
      isEnvironmentOpen: false,
      propDataEnhanced: {
        data: {
          pick_ups: [],
        },
      },
    };
  },
  computed: {
    storedFavorite() {
      return this.$store.getters['getFavorite'];
    },
    layout() {
      let ret;
      if (typeof this.propdata.layout_array === 'undefined') {
        ret = this.propdata.layout.replace(',', '〜');
      } else {
        ret = this.propdata.layout_array.join('〜');
      }
      return ret;
    },
    builtAtWithin() {
      return this.dateFormated(this.propdata.built_at_within, 'YYYY年M月');
    },
  },
  async created() {
    this.propDataEnhanced = await this.getPropertyData(this.propdata.id);
  },
  mounted() {
    this.list = this.storedFavorite.data;
    if (this.list === null) this.list = [];
    if (this.list.length > 0) this.isAdded = this.list.find(n => n.id.toString() === this.propdata.id.toString()) !== undefined;
  },
  methods: {
    gotoProp() {
      location.href = `/kodate/${this.propdata.id}/`;
    },
    async toggleFavorite() {
      this.list = this.storedFavorite;
      if (this.list === null) this.list = [];
      if (!this.isAdded) {
        await this.addWishList({
          id: +this.propdata.id,
          pageName: this.propdata.name,
          oldPriceMin: +this.propdata.price_min,
          oldPriceMax: +this.propdata.price_max,
        });

        this.isAdded = true;
        this.isBalloon = true;
        setTimeout(() => {
          this.isBalloon = false;
        }, 3000);
      } else {
        await this.deleteWishList(this.propdata.id);
        this.isAdded = false;
      }
      if (this.$route.name === 'FavoriteNew') {
        window.location.href = window.location.href;
      }
    },
  },
};

</script>

<style scoped lang="scss">
* {
  font-size: 14px;
}
.u-circleArrow {
  width:25px;
  height:25px;
  border: 2px solid #E83532;
  border-radius: 50%;
  display:flex;
  justify-content: center;
  align-items: center;
  font-weight:bold;
}
.c-cardWrapper {
  position:relative;
  width: 346px;
  height: 100%;
}
.c-card {
  position: relative;
  display: inline-block;
  width: 346px;
  height: 100%;
  border: 1px solid #CCC;
  box-sizing: border-box;
  background-color: #FFF;
  &__leadButton {
    display: block;
    width: 100%;
    font-family: 'メイリオ', 'Meiryo', sans-serif;
    color:#E83532;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    padding: 16px 0;
    margin-bottom: 13px;

    &__sub {
      font-size: 13px !important;
    }
    img {
      width: 29px;
      height: 29px;
    }
  }
  &--image {
    display: block;
    position:relative;
    width: 344px;
    height: 144px;
    overflow: hidden;
      img {
        object-fit: cover;
        width: 344px;
        height: 144px;
      }

    &__info {
      z-index: 101;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: absolute;

      &__banner {
        width: 60%;
        margin: 50px auto 10px;
        line-height: 1.7em;
        font-size: 16px;
        padding: 5px 10px;
        color: #FFF;
        font-weight: bold;
        background-color: #e83532;
        border-radius: 1.5em;
        text-align: center;
      }

      &__drive {
        margin: 10px auto;
        display: block;
        text-align: center;
        font-weight: bold;
      }
    }
    &__filter {
      z-index:100;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(232, 53, 50, 0.2);
      position:absolute;

    }
  }

  p {
    margin: 10px;
  }
  &__area {
    display: flex;
    align-items: center;
  }
  &__areaTitle {
    margin-right: 10px;
    font-size: 12px;
    color: #888888;
    line-height: 1.2;
    word-break: keep-all;
  }
  &__areaText {
    font-size: 12px;
    color: #888888;
    line-height: 1.3;
  }
  &__favorite {
    position: absolute;
    background-color: transparent;
    width: 32px;
    height: 31px;
    top: 40px;
    right: 5px;
    background-size: cover;
    margin: 4px;
    z-index: 110;
    &--balloon {
      position:absolute;
      display:block;
      top: -75px;
      left: calc(50% - 146px);
      z-index: 111;
    }
    &__on {
      background-image: url(/static/img/favorite-selected.png);
    }
    &__off {
      background-image: url(/static/img/icon-favorite.png);
    }
  }
  &__layout {
    margin: 15px 10px 10px !important;
    font-size: 16px;
    font-weight: bold;
  }
  &__kind {
    display: block;
    padding: 11px 8px;
    background-color: rgba(0, 0, 0, 0.5);
    color: #FFF;
    font-size: 14px;
    word-break: keep-all;
  }
  &__price {
    font-weight: bold;
    font-size: 20px;
    color: #E83532;
  }
  &__pullDownArea {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 10px 10px 14px;

    &--oneLine {
      padding: 10px;
      align-items: flex-start;
      background: #EFEFEF;
    }
  }
  &__pullDownText {
    margin: 0 10px 0 0 !important;
    font-size: 16px;
    line-height: 1.5;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    font-size: 12px;
    -webkit-line-clamp: 30;

    &__img {
      display:flex;
      flex-basis: 18px;
      flex-shrink: 0;
      justify-content: center;
      align-items: center;
      height: 18px;
      width: 18px;
      cursor: pointer;
      & img {
        width: 100%;
        height: 100%;
      }
    }
    &--oneLine {
      font-weight: normal;
      -webkit-line-clamp: 1;
    }
  }
  &__topLabel {
    display: flex;
    align-items: center;
  }
  &__kodateName {
    margin-left: 10px;
    font-size: 16px;
    font-weight: bold;
    background: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  &__compArea {
    margin-top: 15px;
  }
  &__compText {
    font-size: 12px;
    line-height: 1.5;
  }
  &__companyName {
    font-size: 12px;
    font-weight: bold;
    line-height: 1.5;
  }
  &__companyAddress {
    font-size: 12px;
    line-height: 1.5;
  }
  &__companyTel {
    display: block;
    padding: 10px;
    margin: 10px;
    font-size: 14px;
    line-height: 1.5;
    background: #EFEFEF;
  }
  &__link {
    display: inline-block;
    width:100%;
    &:hover {
      opacity: 0.8;
    }
  }
}

@media screen and (max-width: 767px)  {
  .c-cardWrapper {
    width: 100%;
  }
  .c-card {
    width: 100%;

    &--image {
      width: 100%;

      img {
        width: 100%;
      }
    }
  }
}

</style>
